import { useContext } from "react";
import getVisualColor from "./getVisualColor.mjs";
import { useTheme } from "@emotion/react";
import backgroundColorContext from "./backgroundColorContext.mjs";
function useIsSameBackground(color) {
  const theme = useTheme();
  let containerBackgroundColor = useContext(backgroundColorContext);
  let visualColor = getVisualColor(containerBackgroundColor, theme.getColor(color));
  return visualColor && visualColor === containerBackgroundColor;
}
export { useIsSameBackground as default };